import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

let sessionId: string | null = null;

const getSessionId = () => {
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
  return sessionId;
};

export const useAdTracking = (adId: string, eventType: 'impression' | 'click' | 'conversion') => {
  const { user } = useAuth();
  const tracked = useRef(false);

  useEffect(() => {
    if (!adId || tracked.current) return;

    const trackEvent = async () => {
      try {
        await (supabase.from as any)('advertisement_analytics').insert({
          advertisement_id: adId,
          event_type: eventType,
          user_id: user?.id || null,
          session_id: getSessionId(),
        });
        tracked.current = true;
      } catch (error) {
        console.error('Error tracking ad event:', error);
      }
    };

    trackEvent();
  }, [adId, eventType, user?.id]);
};

export const trackAdClick = async (adId: string, userId?: string) => {
  try {
    await (supabase.from as any)('advertisement_analytics').insert({
      advertisement_id: adId,
      event_type: 'click',
      user_id: userId || null,
      session_id: getSessionId(),
    });
  } catch (error) {
    console.error('Error tracking ad click:', error);
  }
};

export const trackAdConversion = async (adId: string, userId?: string, metadata?: Record<string, any>) => {
  try {
    await (supabase.from as any)('advertisement_analytics').insert({
      advertisement_id: adId,
      event_type: 'conversion',
      user_id: userId || null,
      session_id: getSessionId(),
      metadata: metadata || {},
    });
  } catch (error) {
    console.error('Error tracking ad conversion:', error);
  }
};
